<py-modal
  [actions]="templateActions"
  [title]="'shoppingLists.export_title' | cxTranslate"
  [centered]="true"
  [scrollable]="true"
  [cxFocus]="focusConfig"
  (esc)="closeModal('escape pressed')"
>
  <div class="d-flex align-items-center">
    <py-reactive-form-checkbox-slider
      [addMargin]="false"
      [group]="formGroup"
      [fieldName]="'displayPrices'"
      [rightLabel]="'shoppingLists.includePrices_heading' | cxTranslate"
      [rightMargin]="true"
    ></py-reactive-form-checkbox-slider>
  </div>
</py-modal>

<ng-template #templateActions>
  <py-action-button
    [buttonClass]="'btn btn-plain-secondary'"
    [type]="'button'"
    [loading]="exportingAsXlsx"
    [buttonLabel]="'shoppingLists.exportToExcel_action' | cxTranslate"
    (activate)="onExportXlsx()"
  >
    <i nz-icon nzType="file-excel"></i>
  </py-action-button>

  <py-action-button
    [buttonClass]="'btn btn-plain-secondary'"
    [type]="'button'"
    [loading]="exportingAsPdf"
    [buttonLabel]="'shoppingLists.exportToPdf_action' | cxTranslate"
    (activate)="onExportPdf()"
  >
    <i nz-icon nzType="file-pdf"></i>
  </py-action-button>
</ng-template>
